<template>
    <div class="tw-relative">
        <flat-pickr
            ref="fpInstance"
            v-model="model"
            :placeholder
            :config="{
                ...config,
                ...flatpickrConfig,
                minDate: min ?? undefined,
                maxDate: max ?? undefined,
            }"
            :required
        />
        <i
            v-if="icon"
            :class="'mdi mdi-' + icon + ' tw-absolute tw-top-[3px] tw-right-2 tw-text-lg tw-my-auto tw-text-gray-600'"
        ></i>
    </div>
</template>

<script setup lang="ts">
import { flatpickrConfig } from '@/js/utils.js';
import { onMounted, useTemplateRef } from 'vue';
import flatPickr from 'vue-flatpickr-component';

const props = defineProps({
    id: {
        type: String,
        required: true,
    },
    placeholder: {
        type: String,
        default: '',
    },
    config: {
        type: Object,
        default: () => ({}),
    },
    required: {
        type: Boolean,
        default: false,
    },
    icon: {
        type: String,
        default: null,
    },
    min: {
        type: String,
        default: null,
    },
    max: {
        type: String,
        default: null,
    },
});

const model = defineModel<string | null>({
    type: String,
    default: null,
});

type FlatPickrRef = {
    fp?: {
        altInput?: HTMLInputElement;
        input: HTMLInputElement;
    };
};

const fpInstance = useTemplateRef<FlatPickrRef>('fpInstance');

onMounted(() => {
    const input = fpInstance.value?.fp?.altInput ?? fpInstance.value?.fp?.input;
    input?.setAttribute('id', props.id);
});
</script>
